// extracted by mini-css-extract-plugin
module.exports = {"root":"TabGroups_root__eBJdn"};